// extracted by mini-css-extract-plugin
module.exports = {"mainContentGeneral":"Disabling_mainContentGeneral__3GV6D","disableContent":"Disabling_disableContent__2gq7D"};